module.exports = __webpack_public_path__ + "assets/img/icon-error-sorry.3accdba5.png";